// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox__XQN7o","selectionBox":"selectionBox__KGmfo","active":"active__Mf98a","someSelection":"someSelection__WGSuh"};